<script>
import moment from 'moment';

import DataLabel from '@/js/components/common/labels/DataLabel';

export default {
    name: 'DateLabel',

    functional: true,

    props: {
        date: {
            type: String,
            default: null,
            validator: (value) => {
                if (!value || value.length === 0) {
                    return true;
                }

                return moment(value).isValid();
            },
        },
        format: {type: String, default: null},
        prefix: {type: String, default: null},
        none: {type: String, default: null},
    },

    render(createElement, {props, data, parent}) {
        if (!props.date || props.date.length === 0) {
            data.props = {none: props.none || parent.$t('common.nil')};

            return createElement(DataLabel, data);
        }

        const format = props.format || parent.$t('common.datetime-format');
        const text = moment(props.date).format(format);

        data.props = {
            item: [props.prefix, text].filter((part) => !!part).join(' '),
            hideIcon: true,
        };

        return createElement(DataLabel, data);
    },
};
</script>
